// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tehL","right":"styles_right__2oKWR"};